import { WorldMapMarkerStory_worldMapView_markers } from 'graphql/query/__generated__/WorldMapMarkerStory';
import { useMarkerVisibilityView } from 'hooks/map/useMarkerVisibilityView';
import { mapGraphQLMarkers } from 'libs/utils/mapping/worldGrahQLMaps';
import { useContext, useMemo } from 'react';
import { CtxView } from 'session/ctxView';

export const useMarkers = () => {
    const ctxView = useContext(CtxView);
    const markerVisibility = useMarkerVisibilityView();
    const isHighlightsVisible = ctxView.visibleMapSetIds.includes('highlights');

    const markers = useMemo(
        () =>
            mapGraphQLMarkers(
                (ctxView.allMarkers ?? []).map<WorldMapMarkerStory_worldMapView_markers>(
                    (marker) => ({
                        ...marker,
                        selectable: markerVisibility.isMarkerSelectableInView(marker),
                        visible:
                            markerVisibility.isMarkerVisibleInViewMap(marker) ||
                            (isHighlightsVisible &&
                                marker.data.__typename === 'WorldMapMarkerDataVariantIconV2' &&
                                marker.data.withStar)
                    })
                )
            ),
        [markerVisibility, ctxView.allMarkers]
    );

    return {
        all: markers
    };
};
